import { Modal } from "components";
import SignedPlacingSlipViewer from "./signed-placing-slip-viewer";

type Props = {
    open: boolean;
    setOpen: (val: boolean) => void;
    offerId: string;
    reinsurerId: string;
    companyName?: string;
};

const ViewSignedPlacingSlipModal = ({
    open,
    setOpen,
    offerId,
    reinsurerId,
    companyName,
}: Props) => {
    return (
        <Modal
            open={open}
            setOpen={setOpen}
            hideActions
            size="6xl"
            title="Signed Placing Slip"
            description={
                companyName
                    ? `Signed placing slip for ${companyName}`
                    : "View signed placing slip document"
            }>
            <SignedPlacingSlipViewer
                offerId={offerId}
                reinsurerId={reinsurerId}
                enabled={open}
            />
        </Modal>
    );
};

export default ViewSignedPlacingSlipModal;
